/* eslint-disable no-useless-computed-key */
import React from 'react';
import {useStyles} from './styles';


const AboutUsCtaContainerSectionPreview = ({
  ctaContainerFrontImage,
  ctaContainerBackImage,
  ctaContainerContent
}) => {
  const classes = useStyles();

  return (
    <div
      className={classes.container}
    >
      <div className={classes.imageContainer}>
        <img
          className={classes.imageFront}
          src={ctaContainerFrontImage}
          alt="CTA Front Image"
        />
        <img
          className={classes.imageBack}
          src={ctaContainerBackImage}
          alt="CTA Back Image"
        />
      </div>
      <div className={classes.contentContainer}>
        <div className={classes.contentMask} />
        <div className={classes.content}>
          <span
            dangerouslySetInnerHTML={{__html: ctaContainerContent}}
          />
        </div>
      </div>
    </div>
  );
};

export default AboutUsCtaContainerSectionPreview;
